export default "__VITE_ASSET__02c02894__"